import OutOfStock from './OutOfStock.vue'

export default OutOfStock
